import { Row, Col, Modal, Tabs, Tab, Tooltip, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import AdminLinksComponent from "../../../components/admin/AdminLinksComponent";
import AdminSalesLinksComponent from "../../../components/admin/AdminSalesLinksComponent";
import { TableHeader, Pagination, Search } from "../../../components/DataTable";
import { useEffect, useState, useMemo } from "react";
import CartItemForOrderComponent from "../../../components/CartItemForOrderComponent";
import OrderItemForOrderPageComponent from "./OrderItemForOrderPageComponent";
import "./invoicePDF.css";
import * as FileSaver from "file-saver";
import ChartsEmbedSDK from '@mongodb-js/charts-embed-dom';
import XLSX from "sheetjs-style";
//import { Tooltip } from '@mui/material';
import { useTrackEvents } from "../../trackEvents/useTrackEvents";
import { useDispatch, useSelector } from "react-redux";

const SalesPageComponent = ({ getOrders, deleteOrder, getDeliveryBooks, fetchCharts }) => {
  const [orders, setOrders] = useState([]);
  const [deliveryBooks, setDeliveryBooks] = useState([])
  const [orderDeleted, setOrderDeleted] = useState(false);
  const [filterValue, setFilterValue] = useState("");
  const [monthProfitMargin, setMonthProfitMargin] = useState(0)
  const { userInfo } = useSelector((state) => state.userRegisterLogin);
  const [filter, setFilter] = useState('month');
  const [filteredOrders, setFilteredOrders] = useState([]);
  const [totalSales, setTotalSales] = useState(0);
  const [totalOrders, setTotalOrders] = useState(0);
  const [topSpendingCompany, setTopSpendingCompany] = useState(0)
  const [topSpendingAmount, setTopSpendingAmount] = useState(0)
  const [totalClients, setTotalClients] = useState(0)
  const [orderCompanies, setOrderCompanies] = useState([])


  useEffect(() => {
    getOrders()
      .then((orders) => {
        setOrders(orders);

        // Extract and log company names
        const uniqueCompanies = [...new Set(orders.map(order => order.userCompany))];
        setOrderCompanies(uniqueCompanies)
      })
      .catch((er) =>
        console.log(
          er.response?.data?.message || er.response?.data || er.message
        )
      );
  }, [orderDeleted]);

  useEffect(() => {
    getDeliveryBooks()
      .then((newData) => {
        setDeliveryBooks((prevData) => {
          const sameData = JSON.stringify(prevData) === JSON.stringify(newData);
          return sameData ? prevData : newData;
        });
      })
      .catch((er) =>
        console.log(
          er.response?.data?.message || er.response?.data || er.message
        )
      );
  }, []);

  // console.log(deliveryBooks);
  // //console.log(orders);
  //console.log("hello");

  useEffect(() => {
    const now = new Date();
    const todayDate = now.getDate();
    const thisMonth = now.getMonth();
    const thisYear = now.getFullYear();
    const firstDayOfWeek = new Date(now);
    firstDayOfWeek.setDate(now.getDate() - now.getDay());
    const lastDayOfWeek = new Date(firstDayOfWeek);
    lastDayOfWeek.setDate(firstDayOfWeek.getDate() + 6);
    const filtered = orders.filter(order => {
      const orderDate = new Date(order.createdAt);
      switch (filter) {
        case 'day':
          return (
            orderDate.getDate() === todayDate &&
            orderDate.getMonth() === thisMonth &&
            orderDate.getFullYear() === thisYear
          );
        case 'week':
          return (
            orderDate >= firstDayOfWeek && orderDate <= lastDayOfWeek
          );
        case 'month':
          return (
            orderDate.getMonth() === thisMonth &&
            orderDate.getFullYear() === thisYear
          );
        case 'year':
          return orderDate.getFullYear() === thisYear;
        case 'all':
        default:
          return true;
      }
    });

    const total = filtered.reduce(
      (sum, order) => sum + (order.orderTotal?.cartSubtotal || 0),
      0
    );

    // Company spending logic
    const companyTotals = {};
    filtered.forEach(order => {
      const company = order.userCompany || 'Unknown';
      const amount = order.orderTotal?.cartSubtotal || 0;
      companyTotals[company] = (companyTotals[company] || 0) + amount;
    });

    let topSpender = null;
    let topSpenderAmount = 0;

    for (const company in companyTotals) {
      if (companyTotals[company] > topSpenderAmount) {
        topSpender = company;
        topSpenderAmount = companyTotals[company];
      }
    }

    setFilteredOrders(filtered);
    setTotalSales(total.toFixed(2));
    setTotalOrders(filtered.length);
    setTopSpendingCompany(topSpender);
    setTopSpendingAmount(topSpenderAmount.toFixed(2));
  }, [filter, orders]);


  useEffect(() => {
    const now = new Date();
    const todayDate = now.getDate();
    const thisMonth = now.getMonth();
    const thisYear = now.getFullYear();

    const firstDayOfWeek = new Date(now);
    firstDayOfWeek.setDate(now.getDate() - now.getDay());

    const lastDayOfWeek = new Date(firstDayOfWeek);
    lastDayOfWeek.setDate(firstDayOfWeek.getDate() + 6);

    const filtered = deliveryBooks.filter(book => {
      const clientCreatedAt = new Date(book.createdAt);
      switch (filter) {
        case 'day':
          return (
            clientCreatedAt.getDate() === todayDate &&
            clientCreatedAt.getMonth() === thisMonth &&
            clientCreatedAt.getFullYear() === thisYear
          );
        case 'week':
          return (
            clientCreatedAt >= firstDayOfWeek && clientCreatedAt <= lastDayOfWeek
          );
        case 'month':
          return (
            clientCreatedAt.getMonth() === thisMonth &&
            clientCreatedAt.getFullYear() === thisYear
          );
        case 'year':
          return clientCreatedAt.getFullYear() === thisYear;
        case 'all':
        default:
          return true;
      }
    });

    //setTotalSales(total.toFixed(2));
    setTotalClients(filtered.length);
  }, [filter, deliveryBooks]);

  /* sort table */
  // #region
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  // const [sorting, setSorting] = useState({ field: "", order: "" });
  const [sorting, setSorting] = useState({ field: "createdAt", order: "desc" });

  const ITEMS_PER_PAGE = 40;
  const columnWidths = [
    "5%",
    "10%",
    "20%",
    "20%",
    "10%",
    "5%",
    "10%",
    "10%",
    "10%",
  ];
  const headers = [
    { name: "No#", field: "index", sortable: false },
    { name: "Name", field: "name", sortable: true },
    { name: "Company", field: "userCompany", sortable: true },
    { name: "Delivery Site", field: "deliverySite", sortable: true },
    { name: "Total Amount", field: "orderTotal.cartSubtotal", sortable: true },
    { name: "Items", field: "items", sortable: true },
    { name: "PO#", field: "purchaseNumber", sortable: true },
    { name: "Invoice#", field: "invoiceNumber", sortable: true },
    { name: "Order Date", field: "createdAt", sortable: true },
  ];

  //Tracking user Interactions
  //useTrackEvents();
  // var trackData = localStorage.getItem("trackData")
  //console.log("trackData", trackData);

  const ordersData = useMemo(() => {
    let computedOrders = orders;

    if (filterValue) {
      computedOrders = computedOrders.filter(
        (order) => order.userCompany === filterValue
      );
    }

    if (search) {
      computedOrders = computedOrders.filter(
        (order) =>
          order.createdAt?.toUpperCase().includes(search.toUpperCase()) ||
          order.purchaseNumber?.toUpperCase().includes(search.toUpperCase()) ||
          order.userCompany?.toUpperCase().includes(search.toUpperCase()) ||
          order.deliverySite?.toUpperCase().includes(search.toUpperCase()) ||
          order.userName?.toUpperCase().includes(search.toUpperCase()) ||
          String(order.orderTotal.cartSubtotal)
            .toUpperCase()
            .includes(search.toUpperCase()) ||
          order.invoiceNumber?.toUpperCase().includes(search.toUpperCase()) ||
          order.userCompany?.toUpperCase().includes(search.toUpperCase()) ||
          order.adminNote?.toUpperCase().includes(search.toUpperCase()) ||
          (
            order.user?.name.toUpperCase() +
            " " +
            order.user?.lastName.toUpperCase()
          ).includes(search.toUpperCase()) ||
          order.cartItems.some((cartItem) =>
            cartItem.name?.toUpperCase().includes(search.toUpperCase())
          ) ||
          order.cartItems.some(
            (cartItem) =>
              cartItem.cartProducts &&
              cartItem.cartProducts.length > 0 &&
              cartItem.cartProducts[0].ctlsku &&
              cartItem.cartProducts[0].ctlsku
                .toUpperCase()
                .includes(search.toUpperCase())
          ) ||
          order.cartItems.some(
            (cartItem) =>
              cartItem.cartProducts &&
              cartItem.cartProducts.length > 0 &&
              cartItem.cartProducts[0].suppliersku &&
              cartItem.cartProducts[0].suppliersku
                .toUpperCase()
                .includes(search.toUpperCase())
          )
      );
    }

    setTotalItems(computedOrders.length);

    //Sorting products
    // as localeCompare only can compare String, we have to update it as below.
    // nested property 嵌套的数据，不能直接获取，容易报错。所以用下面的公式去解析 orderTotal.cartSubtotal
    const getNestedProperty = (obj, path) => {
      return path.split(".").reduce((acc, part) => acc && acc[part], obj);
    };

    if (sorting.field) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedOrders = computedOrders.sort((a, b) => {
        const fieldA = getNestedProperty(a, sorting.field);
        const fieldB = getNestedProperty(b, sorting.field);

        if (typeof fieldA === "number" && typeof fieldB === "number") {
          return reversed * (fieldA - fieldB);
        } else if (typeof fieldA === "string" && typeof fieldB === "string") {
          return reversed * fieldA.localeCompare(fieldB);
        } else {
          // If field types are different, compare their string representations
          return reversed * String(fieldA).localeCompare(String(fieldB));
        }
      });
    }

    //Current Page slice
    return computedOrders.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [orders, currentPage, search, sorting, filterValue]);

  // console.log("ordersData", ordersData);

  // #endregion

  const deleteHandler = async (orderId) => {
    if (window.confirm("Are you sure?")) {
      deleteOrder(orderId);
      setOrderDeleted(true);
      setTimeout(() => {
        setOrderDeleted(false);
      }, 500);
    }
  };

  // order items Modal and Back Order
  const [show, setShow] = useState(false);

  const handleClose = () => {
    setShow(false);
  };
  const handleShow = (orderId) => {
    setSelectedOrderId(orderId);
    setShow(true);
  };

  const [selectedOrderId, setSelectedOrderId] = useState(null);

  // console.log(selectedOrderId);

  const getOrderStyle = (order) => ({
    cursor: "pointer",
    color: order.backOrder ? "red" : "black",
    fontWeight: order.backOrder ? "bold" : "normal",
  });

  //Purchased products list.
  var orderProductsList = [];
  ordersData.map((order) => {
    order.cartItems.map((item) => { });
  });

  //Export to Excel
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";
  const fileName = "Order_products";

  const exportToExcel = async () => {
    const ws = XLSX.utils.json_to_sheet(orderProductsList);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  };

  //CHART SECTION//
  const [chart, setChart] = useState();
  const [charts, setCharts] = useState();
  const [selectedUrl, setSelectedUrl] = useState("");
  const [selectedId, setSelectedId] = useState("")

  useEffect(() => {
    fetchCharts()
      .then((data) => {
        setCharts(data);
      })
      .catch((er) =>
        console.log(
          er.response.data.message ? er.response.data.message : er.response.data
        ));
  }, [0]);

  useEffect(() => {
    setSelectedUrl(charts ? charts[0]?.baseUrl : "")
    setSelectedId(charts ? charts[0]?.chartId : "")
    charts?.map((char) => {
      if (char?.name === "Monthly Sales") {
        setSelectedUrl(char.baseUrl)
        setSelectedId(char.chartId)
      }
    }
    )
  }, [charts])

  useEffect(() => {
    if (selectedUrl !== "" && selectedId !== "") {
      const sdk = new ChartsEmbedSDK({ baseUrl: selectedUrl })
      setChart(sdk.createChart({
        chartId: selectedId,
        height: "650px",
        width: "100%",
        showAttribution: false
      }))
    }

  }, [selectedId])

  useEffect(() => {
    renderChart();
  }, [chart])

  async function renderChart() {
    await chart.render(document.getElementById("chart"));

  }

  return (
    <>
      <Row className="content-container m-5">
        <Col md={2}>
          <AdminSalesLinksComponent />
        </Col>
        <Col md={10}>
          <div className="row">
            <div className="col-md-5" style={{ width: "33%" }}>
              <h1>SALES PORTAL</h1>
            </div>
          </div>

          {/* Stats Cards */}
          <div className="row mb-3" style={{ backgroundColor: "#D3D3D3" }}>
            {/* Filter Buttons */}
            <div className="mb-0 text-center">
              {['day', 'week', 'month', 'year', 'all'].map((type) => (
                <button
                  key={type}
                  className={`btn btn-sm m-1 ${filter === type ? 'btn-primary' : 'btn-outline-primary'}`}
                  onClick={() => setFilter(type)}
                >
                  {type.charAt(0).toUpperCase() + type.slice(1)}
                </button>
              ))}
            </div>
            <div className="col-md-3" style={{ width: "25%", textAlign: "center" }}>
              <div className="card p-3 shadow-sm mt-1 mb-3">
                <h5>Total Sales</h5>
                <p><b>${new Intl.NumberFormat('en-US').format(totalSales)}</b></p>
              </div>
            </div>
            <div className="col-md-3" style={{ width: "25%", textAlign: "center" }}>
              <div className="card p-3 shadow-sm mt-1 mb-3">
                <h5>Total Orders</h5>
                <p><b>{totalOrders}</b></p>
              </div>
            </div>
            <div className="col-md-3" style={{ width: "25%", textAlign: "center" }}>
              <div className="card p-3 shadow-sm mt-1 mb-3">
                <h5>Total Clients</h5>
                <p><b>{totalClients}</b></p>
              </div>
            </div>
            <div className="col-md-3" style={{ width: "25%", textAlign: "center" }}>
              <div className="card p-3 shadow-sm mt-1 mb-3">
                <h5>Top Client</h5>
                <p><b>{topSpendingCompany} (${topSpendingAmount})</b></p>
              </div>
            </div>
          </div>
          <div className="row mb-3 pt-3 pb-3" style={{ backgroundColor: "#D3D3D3" }}>
            <div id="chart"></div>
          </div>

        </Col>
      </Row>
      <Modal show={show} onHide={handleClose} className="order_preview_items">
        <OrderItemForOrderPageComponent id={selectedOrderId} />
      </Modal>
    </>
  );
};

export default SalesPageComponent;
